import type { PMIssue } from "@/domains/pm/types";

function compareDates(a: string | null, b: string | null): number {
  if (!a) return b ? 1 : 0;
  if (!b) return -1;
  if (a === b) return 0;
  return a < b ? -1 : 1;
}

/** Soonest first, unscheduled last — the neighbours in time are the likely picks. */
export function sortCandidates(candidates: PMIssue[]): PMIssue[] {
  return [...candidates].sort((a, b) => {
    const dateOrder = compareDates(a.start_date ?? a.due_date, b.start_date ?? b.due_date);
    return dateOrder || a.issue_number - b.issue_number;
  });
}
